import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Loading from 'vue-loading-overlay';
import axios from 'axios'
import VueAxios from 'vue-axios'
import Maska from 'maska'// Import stylesheet

import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
import GlobalTest from './components/global_components/test.vue'
import Gl_header from './components/header.vue'
import Gl_leftmenu from './components/leftmenu.vue'
import Gl_backbutton from './components/elements/bacl-button.vue'



createApp(App)
    .use(router)
        .use(Loading)
        .use(VueAxios, axios)
        .use(Maska)
        .component('GlobalTest', GlobalTest)
        .component('Gl_header', Gl_header)
        .component('Gl_leftmenu', Gl_leftmenu)
        .component('Gl_backbutton', Gl_backbutton)
        .mount('#app')
